import { StatusCarte } from '@/enum/StatusCarte';
import Vue from 'vue'

export const statusCarte = (value: number) => {    
    switch(value){
        case StatusCarte.valide: return "Valide"
        case StatusCarte.complet: return "Complète"
        case StatusCarte.perime: return "Périmée"
    } 
    return "";    
}
Vue.filter('statusCarte', statusCarte)